module.exports = __webpack_public_path__ + "img/erp_tab01_img_l.0d41d625.png";